export default {
  more: "Тағы",
  freeUser: "Тегін",
  at: "ат",
  days: "күн",
  serviceUnavailable: "сервис қолжетімсіз",
  serviceUnavailableCapitalize: "Cервис қолжетімсіз",
  room: "Кабинет",
  Chief: "Басшы",
  Admin: "Әкімші",
  Manager: "Менеджер",
  heading: "Хабарламаларды жіберің алмаңыз",
  text: "Хабарламаларды қосыңыз. Браузер хабарламаларды жіберуге рұқсат беруді сұрайды — рұқсат беріңіз. АТИ-дан келген осы хабарламадан кейін сіз қай сайтта отырсаңыз да , экранның төменгі жағында пайда болады.",
  btnText: "хабарландыруды қосу",
  importantMessagesPluralize: {
    one: "маңызды хабарлама",
    few: "маңызды хабарлама",
    many: "маңызды хабарлама",
    other: "маңызды хабарлама",
  },
  CoWorker: "Қызметкер",
  score: "Шот",
  firman: "Лицензиялар",
  paidFor: "дейін төленген", // ?
  add: "Қосу",
  extend: "Ұзарту",
  freeAccess: "Сіз тегін кіре аласыз",
  licenseDescr:
    "Сіз тегін машиналар мен жүктерді ғана пайдалана аласыз. Барлығын көру үшін — лицензияны сатып алыңыз.",
  whatLicensed: "Лицензиялар тағы не береді?",
  selectLicense: "Лицензияны таңдау",
  settings: "Теңшеу",
  recurrentPaymentFailed: "Автотөлемді есептен шығару мүмкін емес",
  moreInfo: "Толығырақ",
  pay: "Төлеу",
  conditions: "Талаптар",
  logout: "Шығу",
  view: "Қарау",
  readLater: "Кешірек оқимын",
  participantsSearch: "АТИ қатысушыларын іздеу",
  advancedSearch: "Кеңейтілген іздеу",
  advanced: "Кеңейтілген іздеу",
  cannotFindFirm: "Біз бұндай қатысушыны тапқан жоқпыз.",
  somethingWentWrong: "Қате болды.",
  somethingWentWrongWithoutDot: "Қате болды",
  byExtendedSearch: "кеңейтілген іздеумен",
  tryUsing: "Пайдаланып көріңіз",
  notificationSettings: "Хабарлама теңшеулері",
  noNewNotifications: "Жаңа хабарламалар жоқ",
  viewedNotifications: "Оқылған хабарламалар",
  downloadLoadsAndTrucks: "АТИ Жүктер және Көлікті жүктеңіз",
  receiveNotifications:
    "Өз телефоныңызға немесе планшетіңізге жаңа жүктер туралы хабарлама алыңыз",
  forAndroid: "Android үшін",
  forIPhoneIPad: "IPhone және IPad үшін",
  markAllAsRead: "Барлығын оқылған деп белгілеу",
  soundOn: "Дыбысты қосу",
  soundMute: "Дыбысты өшіру",
  loads: "Жүктер",
  transport: "Көлік",
  checks: "Тексерулер",
  tenders: "Тендерлер",
  news: "Жаңалықтар",
  forums: "Форумдар",
  docs: "Құжаттар",
  atiDocs: "АТИ-Құжаттар",
  tracking: "Мониторинг",
  shipmentTracking: "GPS-мониторинг",
  insurance: "Сақтандыру",
  ratingOfParticipants: "Рейтинг",
  contacts: "Байланыстар",
  loans: "Қарыздар",
  truckmarket: "Көліктердің сатылуы",
  yourLoads: "Сіздің жүктеріңіз",
  addLoad: "Жүкті қосу",
  searchLoads: "Жүктерді табу",
  load: "Жүк",
  yourTrucks: "Сіздің машиналарыңыз",
  addTruck: "Машинаны қосу",
  searchTrucks: "Машиналарды табу",
  truck: "Машинаны",
  orders: "Тапсырыстар",
  ordersFromYou: "Сіздерден тапсырыстар",
  ordersToYou: "Сізге тапсырыстар",
  ordersToDriver: "Заявка водителю", // !
  vehicleFleet: "Автопарк",
  drivers: "Жүргізушілер",
  organizations: "Ұйымдар",
  contractors: "Контрагенттер мен келісімшарттар",
  boards: "Алаңдар",
  yourBoards: "Сіздің алаңдарыңыз",
  invitationsAndApplications: "Шақыртулар мен өтінімдер",
  youParticipate: "Сіз қатысасыз",
  invitations: "Шақыртулар",
  aboutBoards: "Алаңдар туралы",
  yourTenders: "Сіздің Тендерлеріңіз",
  addTenders: "Тендерді қосу",
  catalogs: "Анықтамалықтар",
  directionsLists: "Бағыттар тізімі",
  companiesList: "Фирмалар тізімі",
  requisites: "Сіздің деректемелеріңіз",
  registration: "Тіркеу",
  toRegister: "Тіркелу",
  login: "кіру",
  toLogin: "кіру",
  code: "Код",
  copied: "көшірілді",
  cars: "Машиналар",
  rating: "Рейтинг",
  veh: "КҚ",
  guaranteedPayment: "Кепілді төлем",
  daysRemaining: ["күн", "күн", "күн"],
  remain: ["қалды", "қалды"],
  paymentHaveToBeReceived: "Төлем дейін түсуі тиіс", // ?
  paymentHadToBeReceived: "Төлем дейін түсуі тиіс болған", // ?
  expired: "мерзімі кешіктірілген",
  avatar: "Аватар",
  accountReplenishment: "Шотты толықтыру",
  from: "",
  rub: "руб",
  aMonth: "айына",
  profile_freeAccessTooltip:
    "Машина немесе жүк қарауға лицензияны белсендендiру арқылы сізге қолжетімді:",
  viewContactsForCarsAndCargoes:
    "Машиналар мен жүктер бойынша контактілерді қарай аласыз",
  viewPassports:
    "Барлық пікірлермен және наразылықтармен бірге ATI.SU қатысушыларының төлқұжаттарын қарау",
  yourContact: "Сіздің контакті",
  noLicenseInfo: "Қолданыстағы лицензиялар туралы ақпарат уақытша қолжетімсіз",
  shortMonths: {
    0: "қаңтар",
    1: "ақпан",
    2: "наурыз",
    3: "сәуір",
    4: "мамыр",
    5: "маусым",
    6: "шілде",
    7: "тамыз",
    8: "қыркүйек",
    9: "қазан",
    10: "қараша",
    11: "желтоқсан",
  },

  /** месяца в родительном падеже */
  januaryGen: "қаңтар",
  februaryGen: "ақпан",
  marchGen: "наурыз",
  aprilGen: "сәуір",
  mayGen: "мамыр",
  juneGen: "маусым",
  julyGen: "шілде",
  augustGen: "тамыз",
  septemberGen: "қыркүйек",
  octoberGen: "қазан",
  novemberGen: "қараша",
  decemberGen: "желтоқсан",

  year: "ж.",
  download: "Жүктеу",
  notificationsPluralize: {
    few: "жаңа хабарлама",
    many: "жаңа хабарлама",
    one: "жаңа хабарлама",
    other: "жаңа хабарлама",
  },
  messagesPluralize: {
    oneNumber: "жаңа хабарлама",
    fewNumbers: "жаңа хабарлама",
    manyNumbers: "жаңа хабарлама",
    other: "жаңа хабарлама",
  },
  remainPluralize: {
    one: "қалды",
    few: "қалды",
    many: "қалды",
    other: "қалды",
  },
  daysRemainingPluralize: {
    one: "күн",
    few: "күн",
    many: "күн",
    other: "қалды",
  },
  contactsByLicense: {
    one: "қосымша контакт",
    few: "қосымша контакт",
    many: "қосымша контакт",
    other: "қосымша контакт",
  },
  youHave: "Сізде",
  allRead: "Барлығы оқылған",
  createBoard: "Алаңды құру",
  unreadNotifications: "Оқылмаған хабарламалар",
  noUnreadNotifications: "Оқылған хабарламалар жоқ",
  notifications: "Хабарламалар",
  atiMessenger: "АТИ Мессенджер",
  viewUnread: "Оқылмағандарды қарау",
  readAll: "Барлығын қарау",
  viewAll: "Барлығын оқу",
  automaticPaymentEnabled: "Автотөлем қосылды",
  clickBackAndTryAgain:
    "Артқа батырмасын басып, тағы да бір рет әрекет жасап көріңіз.",
  back: "Артқа",
  sorrySomethingWentWrong: "Қате болды.",
  loadingError: "Жүктеуде қате бар.",
  addingNewLicensesWillBeAvailableAfterRenewal:
    "Жаңа лицензияларды қосу ұзартудан кейін қолжетімді болады",
  searchParticipants: "Қатысушыларды іздеу",
  stars: "Жұлдыздар",
  refresh: "Жаңарту",
  loadsOnBoards: "Жүктер алаңда",
  sorrySomethingWentWrongPleaseTryAgain:
    "Қате болды, тағы да бір рет әрекет жасап көріңіз",
  participantHasNoPaidLicenses: "Пайдаланушыда төленген лицензия жоқ",
  anErrorHasOccurredRefreshThePage: "Қате болды, бетті жаңартыңыз",
  weRecommend: "Біз ұсынамыз",
  or: "немесе",
  theSiteWillWorkMoreStable: "Онда сайт анағұрлым тұрақты жұмыс істейді",
  ICantUseAnotherBrowser: "Мен өзге браузерді пайдалана алмаймын",
  howToInstallAnotherBrowser: "Өзге браузерді қалай орнату керек",
  tnxForVote: "Даусыңыз үшін рақмет",
  confirm: "Растау",
  resend: "Қайталап жіберу",
  sendCode: "Кодты жіберу",
  cancel: "Болдырмау",
  codeSent: "Код жіберілді",
  codeSentOnNewEmail: "Жаңа поштаға растауға арналған коды бар хат жолданды.",
  resendAgain: "сек кейін",
  seconds: "қайтадан жіберу",
  loanAvailable: "Сізге қолжетімді",
  cargoOwnerButtonAvailable: "ATI.SU с нуля",
  youCan: "Сіз хабарлама теңшеулерінде  тарта",
  unsubscribeFrom: "жіберілімдерден бас",
  turnPartnerOffers: "тарта аласыз",
  inNotificationSettings: "хабарландыру параметрлерінде",
  youCanUnsubscribeFromPartners:
    "Сіз {{inSettings}} ATI.SU серіктестерінің ұсыныстарынан бас тарта аласыз",

  // ======
  allServices: "Барлық сервистер",

  automationHeader: "Тасымалдарды автоматтандыру",
  statisticHeader: "Статистика",
  securityHeader: "Қауіпсіздік",
  comunicationHeader: "Қарым-қатынас",
  addInstrumentsHeader: "Қосымша құралдар",
  usefulHeader: "Пайдалы",

  apiLink: "API ATI.SU",
  apiLinkDescription: "Өз корпоративтік БЖ ATI.SU сервистерімен біріктіріңіз.",
  automationLink: "Автоматтандыру",
  gpsLink: "GPS-мониторинг",
  gpsDescription:
    "Көліктің орналасқан жерін және тасымалдау мәртебесін онлайн қадағалаңыз",
  docsLink: "АТИ-құжаттары (ЭҚА)",
  docsDescription: "Эл. құжаттарды құрып, әріптестермен алмасыңыз.",
  ordersLink: "Тапсырыстар",
  ordersDescription:
    "Тасымалдауды толығымен автоматтандырыңыз — әріптестерді іздеуден бастап талдауға дейін",
  boardsLink: "ATI.SU алаңдары",
  boardsDescription:
    "Сенімді әріптестермен жұмысқа арналған өз платформаңызды құрыңыз",
  tendersLink: "Тендерлер",
  tendersDescription:
    "Ондаған және жүздеген тасымалға ұзақ мерзімді келісімшарттарды жасаңыз",
  auctionLink: "Сауда-саттық",
  auctionDescription: "Жүк үшін оңтайлы бағаны табыңыз",
  indexLink: "ATI.SU FTL РФ индексі",
  indexDescription:
    "РФ-ғы ең танымал бағыттар бойынша мөлшерлемелер динамикасы",
  middlePriceLink: "Орташа мөлшерлемелер",
  middlePriceDescription:
    "РФ-ғы мыңдаған бағыттар бойынша руб/км -гі өзекті мөлшерлеме",
  cargoMapLink: "Жүк картасы",
  profitableDestinationsLink: "Тиімді бағыттар",
  profitableDestinationsDesription: "",
  unlimitedCheckLink: "Контрагенттерді «Репутациядан» шектеусіз тексеру",
  unlimitedCheckDescription:
    "Қауіпсіздік сигналы + есеп + РФ-нан фирмалар бойынша кеңейтілген талдау",
  guaranteePaymentLink: "Тасымалдау ақысының кепілдігі",
  guaranteePaymentDescription: "",
  checkLink: "ATI.SU тексерулері",
  checkShortLink: "Тексерулері",
  checkDescription:
    "Жүктен немесе төлемнен айрылып қалмау үшін заңды тұлғаны, жеке тұлғаны немесе КҚ тексеріңіз.",
  trafficLightLink: "Бағдаршам+",
  trafficLightDescription:
    "Қауіпсіздік сигналы + Ресей мен Қазақстандық фирмалар бойынша есеп",
  messengerLink: "АТИ Мессенджер",
  messengerDescription:
    "Тасымалдау туралы келісіп, ATI.SU қатысушысына фото мен құжаттарды жіберіңіз",
  forumsLink: "Форумдар",
  forumsDescription: "Жаңалықтарды талқылап, тәжірибе мен пікір алмасыңыз",
  realTruckLink: "Белсенді тасымалдаушыларды іздеу",
  realTruckDescription:
    "Жүк ұзақ кетпейтін болса— лайықты тасымалдаушыны табыңыз",
  distanceCalculatorLink: "Арақашықтықты есептеу",
  distanceCalculatorDescription: "Жүк тасымалына арналған бағытты жоспарлаңыз",
  chainsLink: "Жүктер тізбегі",
  chainsDescription:
    "Максималды мөлшерлемемен анағұрлым тиімді тізбекті құрыңыз",
  academyLink: "ATI.SU академиясы",
  academyDescription: "Логистикалық міндеттерді тиімді шешіп үйреніңіз.",
  loansLink: "Қарыздар",
  loansDescription: "АТИ қатысушыларына арналған ерекше талаптар",
  newsLink: "Жаңалықтар",
  newsDescription:
    "Жүк тасымалдары әлеміндегі ең маңызды жаңалықтар туралы бірінші болып біліңіз.",
  partnershipLink: "Рефералды бағдарлама",
  partnershipDescription:
    "Жаңа пайдаланушыларды шақырып, бізбен бірге табыс табыңыз",
  ratingLink: "ATI.SU қатысушылары рейтингі",
  ratingDescription: "Өз өңіріңіздегі ең үздік қатысушыларды табыңыз",
  insuranceLink: "Сақтандыру",
  insuranceDescription:
    "Жүкті немесе жауапкершілікті бір-екі рет қана шертіп, сақтандырыңыз",
  truckmarketLink: "Көліктердің сатылуы",
  truckmarketDescription:
    "Көлік пен арнайы техниканы сатыңыз, сатып алыңыз немесе жалға алыңыз",
  timeSlots: "Уақытша терезелер",
  timeSlotsDescription:
    "Қойманың тиімді жұмысын кезексіз және айыппұлсыз ұйымдастырыңыз",
  partnersOffers: "Серіктестердің арнайы ұсыныстары",
  catalogsLink: "Анықтамалықтар",
  ticketsLink: "Өтініштер (тикеттер)",
  courierLink: "АТИ Курьер",

  loadsSearch: "Жүктерді іздеу",
  mainMenu_loads: "Жүктер",
  trucksSearch: "Машиналарды іздеу",
  mainMenu_trucks: "Машиналар",

  mainMenu_atiDocs_short: "АТИ-Құжаттар",

  cargoOwners: "Жүк иегерлеріне",

  submenu_codeCopied: "Код көшірілді",

  menu_section_loadsAndOrders: "Жүктер мен тапсырыстар",
  menu_addLoad: "Жүкті қосу",
  menu_yourLoads: "Сіздің жүктеріңіз",
  menu_yourTenders: "Сіздің тендерлеріңіз",
  menu_addTenders: "Тендерді қосу",
  menu_yourOrders: "Сізден тапсырыстар",
  menu_reports: "Есептер",
  menu_billing: "ATI.SU төлеу ",

  menu_section_boards: "Алаңдар",
  menu_invitations: "Шақыртулар",
  menu_yourBoards: "Сіздің алаңдарыңыз",
  menu_youParticipate: "Сіз қатысасыз",
  menu_createBoard: "Алаңды құру",
  menu_boards: "Алаңдар",

  menu_section_carrierSearch: "Тасымалдаушыларды іздеу",
  menu_trucksSearch: "Көлікті табу",
  menu_activeCarriers: "Белсенді тасымалдаушылар",
  menu_rating: "Қатысушылар рейтингі",
  menu_safetyMemo: "Қауіпсіздік жадынамасы",

  menu_section_catalogs: "Анықтамалықтар",
  menu_organizations: "Ұйымдар",
  menu_partnersAndContracts: "Контрагенттер мен келісімшарттар",
  menu_yourRequisites: "Сіздің деректемелеріңіз",
  menu_firmLists: "Фирмалар тізімі",
  menu_directionLists: "Бағыттар тізімі",
  menu_catalogs: "Сіздің анықтамалықтарыңыз",
  menu_drivers: "Жүргізушілер",

  carriers: "Тасымалдаушыларға",

  menu_section_trucksAndOrders: "Машиналар мен тапсырыстар",
  menu_addTruck: "Машинаны қосу",
  menu_yourTrucks: "Сіздің машиналарыңыз",
  menu_ordersToYou: "Сізге тапсырыстар",

  menu_section_loadsSearch: "Жүктерді іздеу",
  menu_loadsSearch: "Жүктерді іздеу",
  menu_cargoChains: "Жүктер тізбегі",
  menu_boardsSearch: "Алаңдар",

  menu_boardsLoadsSearch: "Жүктер алаңда",

  menu_section_trucksSearch: "Тасымалдаушыларды іздеу",
  menu_exchange: "ATI.SU биржасы",
  menu_gps: "GPS-мониторинг",

  menu_section_usefull: "Пайдалы",

  menu_section_yourDocuments: "Сіздің құжаттарыңыз",
  menu_section_rouming: "Роуминг",
  menu_section_createDocument: "Құжат жасау",
  menu_inbox: "Кіріс",
  menu_awaitingDecision: "Шешімді күтуде",
  menu_closing: "ATI.SU-дан жабуучу",
  menu_yourCounterparties: "Сіздің контрагенттеріңіз",
  menu_yourCertificates:
    "Сіздің электрондық қолтаңбаңыздың (ЭҚ) сертификаттары",
  menu_invoice: "Төлем үшін шот",
  menu_applicationAgreement: "Шарт-өтінім",
  menu_certificateOfCompletion: "Орындалған жұмыстар актісі",
  menu_otherDocument: "Басқа құжат",

  menu_add_order: "Тапсырыс қосу",

  burger_addLoad: "Жүкті қосу",
  burger_addTruck: "Машинаны қосу",

  bottom_yourLoad: "Сіздің жүктеріңіз",
  bottom_loads: "Жүктер",
  bottom_yourTrucks: "Сіздің машиналарыңыз",
  bottom_trucks: "Машиналар",
  bottom_services: "Қызметтер",
  bottom_orders: "Тапсырыстар",
  bottom_profile: "Профиль",

  mainMenu_atiDocs: "АТИ-құжаттары (ЭҚА)",

  profile_serviceUnavailable: "Cервис қолжетімсіз",
  profile_freeUser: "Тегін",
  profile_atis: "ат.",
  profile_days: "күн",
  profile_yourContact: "Сіздің контакті",
  profile_refresh: "Жаңарту",
  profile_score: "Шот",
  profile_room: "Кабинет",
  profile_logout: "Шығу",
  profile_freeAccess: "Сіз тегін кіре аласыз",
  profile_freeAccessText:
    "Сіз тегін машиналар мен жүктерді ғана пайдалана аласыз. Барлығын көру үшін — лицензияны сатып алыңыз.",
  profile_whatsMore: "Лицензиялар тағы не береді?",
  profile_selectLicense: "Лицензияны таңдау",
  profile_fromPerMonth: "айына 460 ₽ бастап",
  profile_payBefore: "{{val}} дейін төлеу",

  profile_guaranteedPayment: "Кепілді төлем.",
  profile_remainPluralize: {
    one: "Қалды",
    few: "Қалды",
    many: "Қалды",
    other: "Қалды",
  },
  profile_daysRemainingPluralize: {
    one: "күн",
    few: "күн",
    many: "күн",
    other: "күн",
  },
  profile_conditions: "Талаптар",
  profile_pay: "Төлеу",
  profile_settings: "Теңшеу",
  profile_automaticPaymentEnabled: "Автотөлем қосылды",
  profile_paidFor: "{{val}}дейін төленген",
  profile_addingNewLicenses: "Жаңа лицензияларды қосу",
  profile_WillBeAvailableAfterRenewal: "ұзартудан кейін қолжетімді болады",
  profile_add_new: "Лицензия қосу",
  profile_extend: "Ұзарту",
  profile_add: "Қосу",
  profile_recurrentPaymentFailed: "Автотөлемді есептен шығару мүмкін емес",
  profile_code: "Код",

  search_participantsSearch: "ATI.SU қатысушыларын іздеу",
  search_atiParticipantsSearch: "ATI.SU қатысушыларын іздеу",
  search_advancedSearch: "Кеңейтілген іздеу",
  search_advanced: "Кеңейтілген іздеу",
  search_phoneAndEmailRestriction:
    "Телефон нөмірі бойынша іздеу және басқа байланыс ақпараты ақылы мүшелерге қолжетімді.",
  search_pricesAndRates: "Бағалар мен тарифтер",

  nps_recomendChance:
    "Сіз ATI.SU -ды өз таныстарыңызға қаншалықты сенімді ұсынасыз ?",
  nps_errorTryAgain:
    "Тағы да бір сынап көріңіз. Жауапты жіберетін кезде қате болды.",
  nps_rateNoRecommend: "үзілді-кесілді ұсынбаймын",
  nps_rateRecommend: "ұсынатыным анық",
  nps_thanksForRate: "{{val}}-ден 10-ға дейінгі жауабыңыз үшін рақмет",
  nps_from: "ден",
  nps_commentYourAnswer: "Жауапқа түсініктеме беріңіз",
  nps_send: "Жіберу",
  nps_tryAgain: "Тағы да бір рет әрекет жасап көріңіз.",
  nps_errorWhileSending: "Жауапты жіберетін кезде қате болды.",
  nps_answerSended: "Жауап жіберілді. Сауалнамаға қатысқаныңыз үшін рақмет",
  nps_youAlreadyVoted:
    "Сіз дауыс бердіңіз. Сауалнамаға қатысқаныңыз үшін рақмет",

  security_header:
    "ATI.SU арқылы жұмыс істеу қаншалықты қауіпсіз деп ойлайсыз?",
  security_rateNoRecommend: "мүлде қауіпсіз емес",
  security_rateRecommend: "мүлдем қауіпсіз",
  security_headerSuccess: "Жауабыңызға рахмет",
  security_headerDescription: "Қаласаңыз, пікір қалдыра аласыз",

  outdated_outdatedBrowserTitle:
    "Сіздің браузеріңіз дұрыс жұмыс істемеуі мүмкін",
  outdated_ieWasFound:
    "Сіздің браузеріңіз ескірген. ATI.SU биржасы қатесіз жұмыс істеу үшін ұсынылған браузерлердің бірін орнатыңыз:",
  outdated_outdatedBrowserWasFound:
    "Сіздің браузеріңіздің нұсқасы ескірген. ATI.SU биржасы қатесіз жұмыс істеу үшін браузерді жаңартыңыз:",
  outdated_update: "Жаңарту",
  outdated_remindLater: "Бұл туралы кейінірек еске салу",
  outdated_howToUpdate: "Браузерді қалай жаңартуға болады",
  outdated_howToInstallAnotherBrowser: "Браузерді қалай орнатуға болады",

  refresh_attemptsLimitError:
    "Превышено кол-во обновлений, повторите через 5 минут", // !
  notification_unsubscribePartnerText:
    "Сіз осы {{val1}} немесе {{val2}} серіктестеріміздің барлық ұсыныстарын өшіре аласыз",
  notification_unsubscribePartnerATISU:
    "ATI.SU серіктесінің жіберілімінен бас тарта аласыз",
  notification_notificationsSettings: "хабарландыру параметрлерінде",

  feed_checkAll: "Барлығын оқылған деп белгілеу",
  feed_allRead: "Барлығы оқылған",
  feed_showMessegesText: "Мессенджер хабарламаларының мәтінін көрсету",
  feed_groupedMessageCounter: {
    one: "хабарлама",
    few: "хабарлама",
    many: "хабарлама",
    other: "хабарлама",
  },

  mainMenu_analitics: {
    statistika_rynka: "Нарық статистикасы",
    servisy_dlya_analitiki: "Аналитика сервистері",
    dinamika_rynka: "Нарық динамикасы",
    rynok_v_cifrah: "Нарық сандарда",
  },

  menu_analitics_averageRates: "Орташа мөлшерлемелер",
  menu_analitics_cargomap: "Жүк картасы",
  menu_analitics_profitdirections: "Тиімді бағыттар",
  menu_analitics_index: "Индекс",

  /** Это группе строк не нужен перевод */
  languageInformer_title: "Выберите язык интерфейса",
  languageInformer_description:
    "Вы всегда сможете изменить свой выбор в кабинете или подвале сайта.",
  languageInformer_button: "Сохранить",
  /** Конец группы */
};
